import { render, staticRenderFns } from "./DelegationMenu.vue?vue&type=template&id=19377552&scoped=true&"
import script from "./DelegationMenu.vue?vue&type=script&lang=js&"
export * from "./DelegationMenu.vue?vue&type=script&lang=js&"
import style0 from "./DelegationMenu.vue?vue&type=style&index=0&id=19377552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19377552",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19377552')) {
      api.createRecord('19377552', component.options)
    } else {
      api.reload('19377552', component.options)
    }
    module.hot.accept("./DelegationMenu.vue?vue&type=template&id=19377552&scoped=true&", function () {
      api.rerender('19377552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DelegationMenu.vue"
export default component.exports